const KO = ({ width, height, color, ...props }) => (
  <svg
    width={width || '24'}
    height={height || '24'}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.25"
      y="3.67999"
      width="23.5"
      height="16.6429"
      rx="1.75"
      fill="white"
      stroke="#F5F5F5"
      strokeWidth="0.5"
    />
    <mask
      id="mask0_54_3134"
      maskUnits="userSpaceOnUse"
      x="0"
      y="3"
      width="24"
      height="18"
    >
      <rect
        x="0.25"
        y="3.67999"
        width="23.5"
        height="16.6429"
        rx="1.75"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
    </mask>
    <g mask="url(#mask0_54_3134)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 16.0014C14.2092 16.0014 16 14.2105 16 12.0014C16 9.79226 14.2092 8.0014 12 8.0014C9.79091 8.0014 8.00005 9.79226 8.00005 12.0014C8.00005 14.2105 9.79091 16.0014 12 16.0014Z"
        fill="#E01B41"
      />
      <mask
        id="mask1_54_3134"
        maskUnits="userSpaceOnUse"
        x="8"
        y="8"
        width="8"
        height="9"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 16.0014C14.2092 16.0014 16 14.2105 16 12.0014C16 9.79226 14.2092 8.0014 12 8.0014C9.79091 8.0014 8.00005 9.79226 8.00005 12.0014C8.00005 14.2105 9.79091 16.0014 12 16.0014Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_54_3134)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00008 12.5728C9.14294 13.6443 10.8572 14.2871 12.0001 12.5728C13.1429 10.8585 15.4287 10.8585 16.0001 12.5728C16.5715 14.2871 16.0001 16.0014 16.0001 16.0014H8.00008C8.00008 16.0014 6.85722 11.5014 8.00008 12.5728Z"
          fill="#0E4B9C"
        />
      </g>
      <path
        opacity="0.75"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.8648 6.63578C17.7054 6.72782 17.6508 6.93169 17.7428 7.09112L19.1238 9.483C19.2158 9.64243 19.4197 9.69705 19.5791 9.60501L19.9915 9.36691C20.1509 9.27486 20.2056 9.071 20.1135 8.91157L18.7326 6.51969C18.6405 6.36026 18.4366 6.30563 18.2772 6.39768L17.8648 6.63578ZM16.3803 7.49292C16.2208 7.58497 16.1662 7.78883 16.2583 7.94826L17.6392 10.3401C17.7313 10.4996 17.9351 10.5542 18.0945 10.4621L18.5069 10.2241C18.6664 10.132 18.721 9.92814 18.6289 9.76871L17.248 7.37683C17.1559 7.2174 16.9521 7.16278 16.7927 7.25482L16.3803 7.49292ZM3.88643 15.0912C3.79439 14.9317 3.84901 14.7279 4.00844 14.6358L4.42084 14.3977C4.58027 14.3057 4.78413 14.3603 4.87618 14.5197L6.25713 16.9116C6.34918 17.071 6.29455 17.2749 6.13512 17.367L5.72273 17.6051C5.5633 17.6971 5.35943 17.6425 5.26739 17.483L3.88643 15.0912ZM5.49301 13.7787C5.33357 13.8707 5.27895 14.0746 5.371 14.234L6.75195 16.6259C6.844 16.7853 7.04786 16.84 7.20729 16.7479L7.61968 16.5098C7.77911 16.4178 7.83374 16.2139 7.74169 16.0545L6.36074 13.6626C6.26869 13.5032 6.06483 13.4485 5.9054 13.5406L5.49301 13.7787ZM17.6392 13.6626C17.7312 13.5031 17.9351 13.4485 18.0945 13.5406L18.5069 13.7787C18.6664 13.8707 18.721 14.0746 18.6289 14.234L17.248 16.6259C17.1559 16.7853 16.9521 16.8399 16.7927 16.7479L16.3803 16.5098C16.2208 16.4177 16.1662 16.2139 16.2583 16.0544L17.6392 13.6626ZM19.5791 14.3977C19.4197 14.3057 19.2158 14.3603 19.1238 14.5197L17.7428 16.9116C17.6508 17.071 17.7054 17.2749 17.8648 17.3669L18.2772 17.605C18.4366 17.6971 18.6405 17.6425 18.7326 17.483L20.1135 15.0911C20.2056 14.9317 20.1509 14.7278 19.9915 14.6358L19.5791 14.3977ZM5.26739 6.51973C5.35943 6.3603 5.5633 6.30568 5.72273 6.39773L6.13512 6.63582C6.29455 6.72787 6.34918 6.93173 6.25713 7.09116L4.87618 9.48304C4.78413 9.64247 4.58027 9.6971 4.42084 9.60505L4.00844 9.36696C3.84901 9.27491 3.79439 9.07105 3.88643 8.91161L5.26739 6.51973ZM7.20729 7.25487C7.04786 7.16282 6.844 7.21745 6.75195 7.37688L5.371 9.76876C5.27895 9.92819 5.33357 10.1321 5.49301 10.2241L5.9054 10.4622C6.06483 10.5542 6.26869 10.4996 6.36074 10.3402L7.74169 7.94831C7.83374 7.78888 7.77911 7.58501 7.61968 7.49296L7.20729 7.25487Z"
        fill="#262626"
      />
    </g>
  </svg>
);

export default KO;
